export const state = () => ({
  loading: false
})

export const mutations = {
  set (state, loading) {
    state.loading = loading
  }
}